<template>
  <div class="">
    <b-card>
      <div class="">
        <!-- {name:null,saldo:null,immediate:null, enlistment:null} -->
        <General :dataParams="measureItems" ></General>
      </div>
      <div class="">
        <AddItems :dataParams="measureItems"></AddItems>
      </div>
      <div class="center">
        <b-button size="lg" @click="createRequest" variant="spotify" class="btn-brand"><i class="fa fa-floppy-o"></i><span>Guardar</span></b-button>
      </div>
    </b-card>
  </div>
</template>
<script>
import General from '@/components/modules/papeleria/requests/form/general.vue'
import AddItems from '@/components/modules/papeleria/requests/form/additems.vue'
export default {
  name: 'Forms',
  components: {
    General,
    AddItems
  },
  props: {
    typeEndPoint: { required: true },
    dataParams: {}
  },
  data () {
    return {
      itemsReactive: {}
    }
  },
  mounted () {
    this.measureItems = this.dataParams
    this.loadEditData()
  },
  computed: {
    measureItems: {
      get: function () {
        return this.itemsReactive
      },
      set: function (newValue) {
        this.itemsReactive = newValue
      }
    }
  },
  methods: {
    createRequest: function () {
      let form = document.getElementById('form-create')
      var formData = new FormData(form)
      let jsonObject = {}
      for (const [key, value] of formData.entries()) {
        jsonObject[key] = value
      }
      let products = JSON.parse(localStorage.getItem('RequestItems'))
      jsonObject['products'] = products
      let total = 0
      for (var i = 0; i < products.length; i++) {
        total = parseInt(products[i].total) + parseInt(total)
      }
      if (!form.saldo.value >= total) {
        alert('No puedes superar el saldo.')
      } else {
        jsonObject['total'] = total
        let store = JSON.parse(localStorage.getItem('requestValidate'))
        console.log(store.id)
        jsonObject['idStudent'] = store.id
        let json = JSON.stringify(jsonObject)
        this.$store.dispatch('papeleriaRequestsCreate', json).then((response) => {
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        })
      }
    },
    loadEditData: function () {
      console.log(this.measureItems)
      if (!this.measureItems.id) {
        this.measureItems = { name: null, saldo: null, immediate: null, enlistment: null }
      } else {
        let json = JSON.stringify(this.measureItems)
        this.$store.dispatch('papeleriaRequestsShow', json).then((response) => {
          let data = this.$store.getters['papeleriaRequests']
          let json = JSON.stringify(data)
          localStorage.setItem('requestValidate', json)
          console.log(data)
        }).catch((error) => {
          // eslint-disable-next-line
          console.error(error)
        })
      }
    }
  }
}
// visualizado.. en la app. punto de entrega...
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/requests/form.vue